<template>
  <div id="zfbProductDetailPage">
    <div class="mainContent">
      <img src="../../../../static/images/product/zfb/details-1.png" alt="" >
      <div class="frequentlyAskedQuestion">
        <div class="title">常见问题</div>
        <van-collapse v-model="questionName" accordion>
          <van-collapse-item title="谁能保？" name="1" title-class="titleUnit">
            <div class="answer">
              <span class="label">肇庆市城乡居民、城镇职工基本医疗保险参保人</span>
              均可参保肇庆市普惠型商业补充医疗保险“肇福保”，
              <span class="label">不限制参保人年龄、职业及既往病史。</span>
            </div>
          </van-collapse-item>
          <van-collapse-item title="怎么保？" name="2" title-class="titleUnit">
            <div class="answer">
              扫“肇福保”二维码或关注“<span class="label">肇福保</span>”公众号或通过“<span class="label">粤省事</span>”投保
            </div>
          </van-collapse-item>
          <van-collapse-item title="保什么？" name="3" title-class="titleUnit">
            <div class="answer">
              涵盖<span class="label">医保政策内、医保政策外住院+门特合规医疗费</span>
              用报销，还<span class="label">包含15种国内特药、60种海外特药及6种院外罕见病特药的报销及配送服务</span>。
            </div>
          </van-collapse-item>
          <van-collapse-item title="怎么赔？" name="4" title-class="titleUnit">
            <div class="answer">
              ① "一站式" 结算
              <br/>
              全市多家定点医疗机构“一站式”结算，<span class="label">出院即理赔</span>，出院结算单可查阅“肇福保”报销金额，轻松结算更省心。适用医院“一站式”结算的情况：本市医院就诊经肇庆市医疗保险信息系统结算的合规医疗费用。
              <br/>
              ② 零星理赔
              <br/>
              适用零星理赔的情况：
              <br/>

              <span class="label">A、异地就医已进行医保结算的医疗费用</span>
              <br/>
              参保人异地就医出院时已进行医保异地联网结算的，符合肇福保报销条件的参保人，可通过线下或线上的方式提交零星报销理赔资料，
              <span class="label">通过线上提交零星报销资料的参保人，资料审核通过后，需前往医保归属地的办理点进行线下纸质理赔资料提交，</span>
              所提交的纸质零星报销资料，由肇福保主承办保险公司归档保存。
              <br/>

              <span class="label">B、本市就医或异地就医未进行医保结算的医疗费用</span>
              <br/>
              在符合肇庆市基本医疗保险相关政策规定的前提下，如被保险人因特殊原因在本市或异地就医未能及时进行医保联网结算的，
              <span class="label">需到肇庆市各医保服务大厅提交医保零星报销，</span>
              其中符合“肇福保”待遇范围的参保人按照A的流程办理理赔报销。
              <br/>

              <span class="label">C、本市其他医疗保障不属于国家医保信息系统结算的医疗费用</span>
              <br/>
              对于不属于肇庆市基本医疗保险信息系统结算的本市其他医疗保障（特指特药待遇），需由参保人通过线下或线上的方式提交零星报销理赔资料，
              <span class="label">通过线上提交零星报销资料的参保人，审核通过后，参保人需前往医保归属地的办理点进行线下纸质理赔资料提交，</span>
              所提交的纸质零星报销资料，由肇福保主承办保险公司归档保存。
              <br/>

              <span class="label">D、异地就医医疗费用垫付</span>
              <br/>
              对于已使用异地就医医疗费用垫付服务的，于出院时由垫付服务公司现场完成结算并由服务公司收取完整的理赔资料，代参保人向保险公司提交理赔申请和办理理赔手续。
            </div>
          </van-collapse-item>
          <van-collapse-item title="肇福保与普通商业健康保险有什么区别？" name="5" title-class="titleUnit">
            <div class="answer">
              ①　肇福保是由肇庆市人民政府批准，肇庆市医疗保障局、肇庆银保监分局等多部门联合主导设计产品内容，经公开招标选定商保公司承保的普惠型保险产品。
              <br/>
              ②　肇福保<span class="label">没有既往病症投保限制</span>，投保肇福保保单生效后，因既往症就医产生的医疗费用，除四大类严重既往症报销比例减半外，其余既往症就医产生的住院和门特医疗费用可按肇福保的待遇进行报销
              <br/>
              ③　肇福保对于基本医保参保类型为城镇职工者，可以使用医保个账历年余额购买，提高医保个帐使用效率；肇福保鼓励使用个帐余额为直系亲属（父母、配偶、子女）参保。
              <br/>
              ④　肇福保可实现定点医疗机构一站式结算，出院时在医保系统直接结算报销。
              <br/>
              ⑤　肇福保承保了住院、门特、15种国内和60种海外特效药、6种指定罕见病特药费用，扩展了医保外费用，保障广泛，保障额度高。
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <img src="../../../../static/images/product/zfb/details-2.png" alt="" >
    </div>
    <footer>
      <div class="footerUnit">
        <a class="kefu" href="https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f">
          <div class="kefu">
            <div class="kefuImg"></div>
            <div class="kefuText">客服</div>
          </div>
        </a>
        <div class="submit" @click="getInterest">立即参保</div>
      </div>
    </footer>

    <!-- 手机验证 - 弹窗 -->
    <van-popup
      v-model="claimPopup"
      round
      :style="{ width: '86%' }"
      class="claimPopup"
    >
      <div class="head">
        <div class="title">温馨提示</div>
        <div class="title-hint">请先校验手机号码再领取权益哦~</div>
      </div>
      <div class="check">
        <el-input type="number" v-model="account" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" class="account"></el-input>
        <el-button @click="receiveCheck" class="receive">立即领取</el-button>
        <div class="cueWords">
          <div class="prompt">
            <span :class="promptStates"></span>
            <span class="errorPrompt" v-html="errorPrompt">{{errorPrompt}}</span>
          </div>
          <div class="contact">如有疑问请致电：<a href="tel:02082513114" >020-82513114</a></div>
        </div>
      </div>
    </van-popup>

    <!-- 参保提示 - 弹窗 -->
    <van-popup
      v-model="promptPopup"
      round
      class="promptPopup"
    >
      <div class="title">参保提示</div>
      <div class="content">
        <div style="text-indent: 2em;"> 您将进入由肇庆市医疗保障局主导，中国太平洋财产保险股份有限公司广东分公司、中国人民财产保险股份有限公司肇庆市分公司、阳光财产保险股份有限公司、泰康养老保险股份有限公司广东分公司4家商业保险公司共同承保的肇庆市普惠型商业补充医疗保险“肇福保”投保操作页面，请您仔细阅读并理解页面内容，并确保所填信息真实准确。根据相关要求，您在投保页面上的操作将被记录并保存，敬请知悉。 </div>
        <div class="viewNotification" @click="openNotificationPopup" >查看告知书</div>
      </div>
      <div class="footer">
        <button @click="understand">
          <span>我知道了</span>
        </button>
      </div>
      <div class="tips">确认并点击“我知道了”，即可进入投保流程</div>
    </van-popup>

    <!-- 告知书 - 弹窗 -->
    <van-popup
      v-model="notificationPopup"
      round
      closeable
      position="bottom"
      class="notificationPopup"
      v-if="notificationPopup"
    >
      <div class="notificationContent">
        <div class="popupTitle">客户告知书</div>
        <div class="content">
          <div class="title">正迅保险经纪有限公司客户告知书</div>
          <div>尊敬的客户：</div>
          <p>感谢您委托我司代为办理保险业务，本公司是基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构。为了保护您的合法权益，按照《保险经纪人监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请仔细阅读。</p>
          <p>一、公司基本情况</p>
          <p>（一）名称：正迅保险经纪有限公司</p>
          <p>（二）住所：广州市黄埔区开创大道2403号1003室</p>
          <p>（三）保险中介许可证机构编码：260591000000800</p>
          <p>（四）经营保险经纪业务许可证有效期至：2024年09月28日</p>
          <p>（五）业务范围：</p>
          <p>第一类：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务。</p>
          <p>第二类：经营互联网保险业务，备案编号：粤ICP备13035223号-3，自营平台名称如下：</p>
          <div>
            <p>经营互联网保险业务的网站名称：</p>
            <p>百家保服；小白云服；米粒保</p>
            <p>经营互联网保险业务的网站地址：</p>
            <p><a href="https://chp.xiaobaibao.com/" target="_blank">https://chp.xiaobaibao.com/</a></p>
            <p><a href="https://xbyf.xiaobaibao.com/" target="_blank">https://xbyf.xiaobaibao.com/</a></p>
            <p><a href="https://yeahka.xiaobaibao.com/" target="_blank">https://yeahka.xiaobaibao.com/</a></p>
            <p>经营互联网保险业务的APP名称：</p>
            <p>小白宝</p>
            <p>经营互联网保险业务的微信公众号名称：</p>
            <p>小白宝；泰运宝在线</p>
          </div>
          <p>（六）经营区域：全国区域内（港、澳、台除外）</p>
          <p>（七）联系方式：020-62324288</p>
          <p>二、请仔细阅读保险条款，保险产品的广告、公告、彩页等宣传资料不属于保险合同的组成部分。请重点关注保险责任、责任免除或者除外责任、特别约定或扩展条款、投保资格要求、犹豫期后解除合同损失、投保人和被保险人权利义务、免赔额或免赔率的计算、等待期等，并可要求本公司业务人员对上述内容进行详细讲解。</p>
          <p>三、请向本公司客服人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。</p>
          <p>四、根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。</p>
          <p>五、本公司已按《保险经纪人监管规定》投保职业责任保险。</p>
          <p>六、保险服务佣金收取方式：本次保险服务佣金由保险公司按保险法规定向我司支付。</p>
          <p>七、如果您发现本公司服务人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司投诉（电话：020-62324288）。</p>
          <br/>
          <p><b>我声明：正迅保险经纪有限公司的服务人员已向我讲解清楚投保的相关事项，我也对上述内容明确理解。</b></p>
        </div>
        <!--<pdf
          v-for="i in numPages"
          :key="i"
          :page="i"
          :src="pdfUnit"
        >
        </pdf>-->
      </div>
    </van-popup>
  </div>
</template>

<script type="text/javascript">
  import pdf from 'vue-pdf'

  export default {
    name: "zfbProductDetailPage",
    components: {pdf},
    data() {
      return {
        questionName: '1',
        eventLogToken: '',
        /* 手机验证弹窗 */
        claimPopup: false,
        account: '',
        rightsToken: '',
        saleToken: '',
        promptStates: 'none',
        errorPrompt: '',
        startTime: '',
        loginAccount: '',
        /* 参保提示 - 弹窗 */
        promptPopup: false,
        /* 告知书 - 弹窗 */
        notificationPopup: false,
        pdfUrl: "https://pic.xiaobaibao.com/clause/2021/10/e18184f2896e4f1883b892726e445f47.pdf",
        pdfUnit: null,
        numPages: null,
      }
    },
    methods: {
      // 我知道了 - 参保提示弹窗
      understand(){
        let that = this;
        that.promptPopup = false;

        that.$router.push({name: "zfbInfoFillingPage", query: {rightsToken: that.rightsToken, eventLogToken: that.eventLogToken}});
      },

      // 客户告知书 - 弹窗
      openNotificationPopup(){
        let that = this;
        that.notificationPopup = true;

        // 解析pdf多页内容
        /*that.pdfUnit = pdf.createLoadingTask(that.pdfUrl);
        that.pdfUnit.promise.then(pdf => {
          that.numPages = pdf.numPages;
          that.notificationPopup = true;
        });*/

      },

      //-- 立即领取权益
      getInterest(){
        let that = this;

        if (that.$$.isValidObj(that.rightsToken)){
          // 参保提示弹窗
          that.promptPopup = true;
        }else {
          that.claimPopup = true;
        }
      },

      //-- 手机号校验
      receiveCheck(){
        let that = this;
        const errorMsg = that.validationForm_phone(that.account);
        console.log(errorMsg);
        if(errorMsg != null) return that.errorPrompt = errorMsg;

        //-- 图形验证
        if (!that.$$.isValidObj(that.startTime)) {
          that.$$.geeTestInit(that);
        }
      },

      //-- 验证手机号
      validationForm_phone(account){
        if(!this.$$.isValidObj(account)) return "请输入手机号~";
        if(!this.$$.constant.phoneReg.test(account)) return "手机号格式错误，请重新输入！";

        return null;
      },

      //-- 权益登录手机校验
      phoneCheck(){
        let that = this;
        let loading = that.Loading.service({fullscreen: true});
        that.axios.post('/member/unicom/check', {phoneNum: that.account, saleToken: that.saleToken, startTime: that.startTime}).then((response) => {
          that.$nextTick(() => loading.close());
          let data = response.data;
          $('.contact').hide();
          that.promptStates = 'none';
          this.rightsToken = '';

          if (data.success) {
            const {rightsToken} = data.datas;
            that.rightsToken = rightsToken;
            that.claimPopup = false;
            that.$message.success('验证通过！');

            //-- 本地缓存 rightsToken
            that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
            that.$$.localStorageSet('interests_loginAccount'+that.saleToken, that.account, 5 * 60 * 1000);
            that.loginAccount = this.account;
          }else {
            that.startTime = '';

            const {msg, code, rightsToken} = data;

            if (that.$$.isValidObj(code)){
              that.securityNumber = code;
              that.rightsToken = rightsToken;

              $('.contact').show();
            }else if (msg.includes('您的权益领取申请正在审核中,请耐心等待!')){
              $('.contact').show();
            }

            that.errorPrompt = msg;
          }
        });
      },

    },
    mounted() {
      let that = this;

      that.saleToken = decodeURIComponent(encodeURIComponent(that.$route.query.saleToken).replace(new RegExp("%20","gm"),"%2B"));

      //-- 获取权益数据
      if (!that.$$.isValidObj(that.saleToken)) {
        that.$$.alert({
          message: '链接参数有误，请重新领取权益!',
          type: 'warning',
          onOk: function () {
            that.$router.go(-1);
          }
        });
      }

      that.account = that.$route.query.account;
      that.rightsToken = decodeURIComponent(encodeURIComponent(that.$route.query.rightsToken).replace(new RegExp("%20","gm"),"%2B"));

      if (that.$$.isValidObj(that.account) && that.$$.isValidObj(that.rightsToken)) {
        //-- 本地缓存 rightsToken
        that.$$.localStorageSet('interests_rightsToken'+that.saleToken, that.rightsToken, 5 * 60 * 1000);
        that.$$.localStorageSet('interests_loginAccount'+that.saleToken, that.account, 5 * 60 * 1000);
        that.loginAccount = this.account;
      }else {
        // 登录状态 - 本地缓存获取
        const rightsToken = that.$$.localStorageGet('interests_rightsToken'+that.saleToken);
        const loginAccount = that.$$.localStorageGet('interests_loginAccount'+that.saleToken);

        if (that.$$.isValidObj(rightsToken) && that.$$.isValidObj(loginAccount)) {
          that.rightsToken = rightsToken;
          that.loginAccount = loginAccount;
          that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
          that.$$.localStorageSet('interests_loginAccount'+that.saleToken, loginAccount, 5 * 60 * 1000);
        }else {
          localStorage.removeItem('interests_rightsToken'+that.saleToken);
          localStorage.removeItem('interests_loginAccount'+that.saleToken);
        }
      }

      // 产品屏幕录制
      let eventLogToken = decodeURIComponent(encodeURIComponent(that.$route.query.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
      if (that.$$.isValidObj(eventLogToken)) {
        that.screenRecBase.startLoad();
        that.eventLogToken = eventLogToken;
      }

    }
  }
</script>

<style scoped>
  #zfbProductDetailPage{
    margin: 0 auto;
    padding-bottom: 5rem;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #04aa7a;
  }

  /* 常见问题 */
  .frequentlyAskedQuestion .title{
    height: 4rem;
    line-height: 4rem;
    padding: 0 4vw;
    color: #ffffff;
    font-size: 1.75rem;
    font-weight: bold;
  }

  .frequentlyAskedQuestion /deep/ .van-cell{
    background: #04aa7a;
    color: #fff;
  }
  .frequentlyAskedQuestion /deep/ .van-icon{
    color: #fff;
  }
  .frequentlyAskedQuestion /deep/ .titleUnit{
    font-size: 1.5rem;
    font-weight: bold;
  }

  .frequentlyAskedQuestion .answer{
    font-size: 1.4rem;
    color: #000000;
  }

  .frequentlyAskedQuestion .label{
    color: #04aa7a;
  }

  /* 底部 */
  footer{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 101;
    background: #ffffff;
    width: 100%;
  }
  .footerUnit{
    margin: 0 auto;
    text-align: center;
    height: 5rem;
    display: flex;
  }
  .kefu{
    padding: 0 1.6rem;
    height: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .kefuImg{
    width: 3rem;
    max-height: 3rem;
    padding-top: 100%;
    background: url("../../../../static/images/product/zfb/kefu.png") no-repeat center / cover;
  }
  .kefuText{
    text-align: center;
    font-size: 1.33rem;
    line-height: 2rem;
  }
  .submit{
    flex: 1;
    background: -webkit-linear-gradient(left,#00b07b,#017a59);
    background: linear-gradient(90deg,#00b07b,#017a59);
    color: #ffffff;
    font-size: 1.5rem;
    line-height: 5rem;
  }

  /* 弹窗 */
  .claimPopup .head{
    width: 100%;
    line-height: 30px;
    border-radius: 15px 15px 0 0;
    padding: 15px 0;
    font-weight: bold;
    background: url("../../../../static/images/product/dialogBg-1.png") no-repeat center / cover;
    letter-spacing: 1px;
  }
  .claimPopup .head .title{
    color: #064f98;
    font-size: 16px;
    text-align: center;
  }
  .claimPopup .head .title-hint{
    color: #333333;
    font-size: 14px;
    text-align: center;
  }

  .claimPopup .check{
    padding: 20px 10%;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
  }

  .claimPopup .receive{
    margin: 15px auto 10px;
  }

  .claimPopup .claim .getInterest>button,
  .claimPopup .receive{
    width: 100%;
    height: 40px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background: #FFBA5F;
    border-radius: 4px;
    border: none;
    clear: both;
  }

  .claimPopup .cueWords{
    display: block;
  }
  .claimPopup .prompt{
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .claimPopup .prompt>span:first-child{
    display: inline-block;
    width: 18px;
    height: 18px;
    margin: 2px 2px 0 0;
  }

  .claimPopup .prompt .errorPrompt{
    max-width: calc(100% - 30px);
    color: #FA6E50;
    font-size: 14px;
    font-weight: bold;
  }
  .claimPopup .prompt .errorPrompt /deep/ a{
    display: inline-block;
    text-decoration: underline;
    color: #1a73e8;
  }

  .contact{
    font-size: 12px;
    color: #999999;
    margin: 20px auto 5px;
    display: none;
  }
  .contact a{
    color: #B98C65;
    display: inline-block;
  }

  /* 参保提示 - 弹窗 */
  .promptPopup{
    padding: 2rem;
    width: 80%;
    z-index: 2100!important;
  }

  .promptPopup .title{
    font-weight: bold;
    font-size: 1.8rem;
    text-align: center;
    color: #333333;
  }

  .promptPopup .content{
    margin: 1.5rem auto;
    padding: 1rem;
    border: 1px solid #999999;
    border-radius: .5rem;
    color: #000000;
    font-size: 1.35rem;
  }

  .promptPopup .viewNotification{
    margin-top: 1rem;
    text-align: center;
    color: #2e77ee;
  }

  .promptPopup .footer button{
    color: white;
    background: linear-gradient(90deg,#00b07b,#017a59);
    border: 0;
    border-radius: 1rem;
    width: 100%;
    height: 4rem;
    font-size: 1.5rem;
    position: relative;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
    -webkit-appearance: none;
  }

  .promptPopup  .tips{
    margin-top: .5rem;
    color: #017a59;
    text-align: center;
  }

  /* 告知书 - 弹窗 */
  .notificationPopup{
    padding: 4rem 0 1rem;
    height: 70%;
    z-index: 2101!important;
  }

  .notificationPopup .notificationContent{
    position: relative;
  }

  .notificationPopup .popupTitle{
    height: 4rem;
    line-height: 4rem;
    width: 100%;
    position: fixed;
    bottom: calc(70% - 4rem);
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2005;
    font-weight: bold;
    font-size: 1.8rem;
    text-align: center;
    color: #333333;
    background: #ffffff;
    border-radius: 16px 16px 0 0;
  }
  .notificationPopup /deep/ .van-popup__close-icon{
    position: fixed;
    top: unset;
    bottom: calc(70% - 4rem);
    z-index: 2006;
  }

  .notificationPopup .content{
    padding: 1rem;
    font-size: 1.4rem;
  }

  .notificationPopup .content .title{
    font-size: 1.6rem;
    font-weight: bold;
    text-align: center;
  }

  .notificationPopup .content p{
    text-indent: 2em;
  }

  .notificationPopup .content p a{
    color: #FA6E50;
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/zfb/productDetailPage.vue